import React, { PropTypes } from 'react'
import {connect} from 'react-redux'
//import NavLink from '../router/NavLink'
import WorkCarousel from './WorkCarousel'
import VideoPlayer from '../video/VideoPlayer'
import {TimelineMax,TweenLite, Linear, Power2, Power3, Power4 ,Back, Circ} from 'gsap'
import 'gsap/src/uncompressed/plugins/ScrollToPlugin';
import SplitText from 'gsap/SplitText'

import KastnerBusinessPopUp from './KastnerBusinessPopUp'

import WorkOneImageRow from './WorkOneImageRow'
import WorkTwoImageRow from './WorkTwoImageRow'

import ScrollArrow from '../scrollarrow/ScrollArrow'

import MultiLangText from '../multilang/MultiLangText'

import VideoLoop from '../video/VideoLoop'

import TextRow from './TextRow'

import MetaTags from 'react-meta-tags'



class WorkItem extends React.Component {


  constructor(){
    super();

    this.state={
      open: false,
      showScrollArrow: false,
      open_tl: null,
      screenHeight: window.innerHeight,
      scrollToInterval: null
    }

    this.openItem = this.openItem.bind(this)
    this.animateOpening = this.animateOpening.bind(this)
    this.checkCopyWidth = this.checkCopyWidth.bind(this)
    this.onResize = this.onResize.bind(this)
    this.scrollToThis = this.scrollToThis.bind(this)
  }

  onResize(){

    this.checkCopyWidth();
  }

  checkCopyWidth(){

    let copy = this.refs.container.querySelector('.description .copy');
    let copyParent = this.refs.container.querySelector('.description');

        copy.classList.remove('small-screen')





        //console.log(copy.offsetWidth,copyParent.offsetWidth);

        if(copy.offsetWidth>copyParent.offsetWidth-40){
            copy.classList.add('small-screen')
        }


  }

  openItem(){
      this.setState({open:true});
  }


  animateOpening(){


    let thisContainer = this.refs.container; //document.querySelector('#workItemContainer');
    let featureImage =  thisContainer.querySelector('.feature-image');

      let open_tl = new TimelineMax()

      let thisContainerPostion = thisContainer.getBoundingClientRect();
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      let thisPageYpos = thisContainerPostion.top+scrollTop

      // TODO: Add scroll disable functionallity


      let background = this.refs.container.querySelector('.background');

      /// Fade in  the content at the top of the page

      //let workType1 = this.refs.container.querySelector('.description .work-type .type1 .inner-type')
      //let workType2 = this.refs.container.querySelector('.description .work-type .type2 .inner-type')
      let location = this.refs.container.querySelector('.description .location')

      let spacer = this.refs.container.querySelector('.description .work-type .spacer')

      let title = this.refs.container.querySelector('.description .title')
      let line  = this.refs.container.querySelector('.description .line')
      let copy = this.refs.container.querySelector('.description .copy')

      let brandTab =  this.refs.container.querySelector('.kastner-brand-tab')

      let copyCover = this.refs.container.querySelector('.description .copy .gradient')

      open_tl.add(()=>{
          document.querySelector('#transitonHolder').classList.add('show');
          document.querySelector('#transitonHolder').classList.add('no-blue-bg');
          document.querySelector('#transitonHolder').classList.add('no-transitions');
          document.querySelector('body').classList.add('disable-pointer-events-and-scroll');

          // set the position again.. just in case there seem to be some inconsitent behaviour..
          let scrollToInterval = setInterval(this.scrollToThis ,40);
          this.setState({scrollToInterval})
      })

      open_tl.fromTo('#work-office-fade-bg',.5,{alpha:0},{alpha:1},'-=0')
      open_tl.fromTo(background,.5,{alpha:0},{alpha:1},'-=.5')
      open_tl.set('#work-office-fade-bg',{alpha:0})
      open_tl.add(()=>{
          document.querySelector('#transitonHolder').classList.remove('show');
          document.querySelector('#transitonHolder').classList.remove('no-blue-bg');


      })

      // HACK:  To make the item not scroll if we don't have a thumb
      if(window.clickedThumb){
        open_tl.set(window,{scrollTo:{y:thisPageYpos}})
        open_tl.add(()=>{
            this.scrollToThis();
        })
        //this.scrollToThis();
      }

      open_tl.add(()=>{
        document.querySelector('body').classList.add('force-hide-header');

      })

      open_tl.add(()=>{
          this.setState({open:true});
          //featureImage.setAttribute('style','')
          clearInterval(this.state.scrollToInterval);
          this.onResize();
      })



      if(window.innerWidth>769){
        open_tl.from(featureImage,3,{alpha:0},'+=.5')
      }





      if(brandTab){
          open_tl.from(brandTab,1,{alpha:0},'-=3')
      //    open_tl.from(title,1,{alpha:0},'-=1')
      }
      //else{
          open_tl.from(title,1,{alpha:0},'-=1.5')
      //}


      //open_tl.from(workType1, 1 ,{x:200},'-=1.5')
      //open_tl.from(workType2, 1 ,{x:-200},'-=1.5')
      //open_tl.fromTo(spacer, .75 ,{alpha:0},{alpha:0.99},'-=1')

      open_tl.from(line,1,{scaleX:0,ease:Power3.easeOut},'-=1');
      open_tl.fromTo(location,1.2,{alpha:0},{alpha:1,ease:Linear.easeNone},'-=1')



      // check the width of the copy
      open_tl.add(()=>{
        this.checkCopyWidth();
          document.querySelector('#transitonHolder').classList.remove('no-transitions');
          document.querySelector('body').classList.remove('disable-pointer-events-and-scroll');
      })

      open_tl.fromTo(copyCover,2,{top:'-100%'},{top:'100%'})
      //open_tl.fromTo(copyCover,.1,{autoAlpha:0})
      //open_tl.from(copy,.7,{alpha:0,ease:Power3.easeOut},'-=.3');

    //open_tl.from(copy,1.5,{scaleY:0,transformOrigin:"0% 0%",ease:Power3.easeOut},'-=.3')





      open_tl.add(()=>{
        this.setState({showScrollArrow:true})
      },'-=.7')

      if(window.innerWidth < 769){
        open_tl.from(featureImage,.5,{alpha:0},'+=0')
      }

      open_tl.add(()=>{
        document.querySelector('body').classList.remove('force-hide-header');
      })


      // Fade in the content rows

      //console.log("content rows",thisContainer.querySelectorAll('.content-row'))

      let contentRows = thisContainer.querySelectorAll('.content-row')
      //console.log('contentRows',contentRows,typeof(contentRows));

      for(let i=0;i < contentRows.length;i++){
        //open_tl.from(contentRows[i],.5,{alpha:0});
      };

      //open_tl.to(window, 1, {scrollTo:'#workItemContainer',ease:Power2.easeInOut},'+=.5');
      //open_tl.timeScale(.5)
      this.setState({open_tl})
  }


  componentDidMount(){




    /*setTimeout(
    this.animateOpening,
    3000);*/

    //console.log();

    //console.log('this.props',this.props);
    if(window.clickedThumb){
      //console.log("window.clickedThumb ",window.clickedThumb.getBoundingClientRect());
      this.animateOpening()

      // clear clickedThumb
      delete window.clickedThumb;

      //this.setState({open:true});
    }else{
      //this.setState({open:true})
      this.animateOpening()
      //this.scrollToThis();

      // delay 500 to make the previous page fade out first
      setTimeout(this.scrollToThis,505);
    }

    // Resize, check if everything fits
    window.addEventListener('resize',this.onResize)
    this.onResize();


  }

  scrollToThis(){

    let thisContainerPostion = this.refs.container.getBoundingClientRect();
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let thisPageYpos = thisContainerPostion.top+scrollTop

    window.scrollTo(0,thisPageYpos);
  }

  componentWillUnmount(){
    window.removeEventListener('resize',this.onResize)
    this.state.open_tl.kill()
  }


  render () {
      //console.log("Work ITEM",this);
      let slug

      (this.props.path)?
        slug = this.props.path.replace('/work/','').replace('/')
      : slug = this.props.item.slug





      let workItem = this.props.workData.data.filter((item) => {
          return(item.slug === slug)
      })[0]

      //console.log('workItem',workItem);

      let active = false;


      let featureImageStyle = {
          backgroundImage:  `url('${workItem.acf.hero_image.url}')`
      }

      if(window.innerWidth < 1025){
        featureImageStyle = {
           backgroundImage:  `url('${workItem.acf.hero_image.sizes.large}')`
       }
      }

      if(window.innerWidth < 767){
        featureImageStyle = {
           backgroundImage:  `url('${workItem.acf.hero_image.sizes.medium_large}')`
       }
      }

      let openClass = (this.state.open)? 'open' : 'closed';


      let lang = 'en'

      // pick subtitle & description depending on language

      let sub_title = workItem.acf.sub_title[lang]
      let description = workItem.acf.description[lang];

      //let workType1 = workItem.acf.work_type[lang+"_type1"]
      //let workType2 = workItem.acf.work_type[lang+"_type2"]


      let titleObj =  {en:workItem.title.rendered};


      if(workItem.acf.title_with_breaks_casestudy){

        for(let i in workItem.acf.title_with_breaks_casestudy){
          if(workItem.acf.title_with_breaks_casestudy[i]){
              titleObj = workItem.acf.title_with_breaks_casestudy
              console.log("Found a title",titleObj);


          }
        }

      }


      let arrowStyle = {}

      if(window.innerWidth < 769){
          arrowStyle = {
            top:'auto',//(this.state.screenHeight - 110)+'px'
            bottom:'50px'
          }


      }


      return (




          <div ref="container" id="workItemContainer" className={"work-item scroll-anchor " +(openClass)} pageslug={'/work/'+slug} >
          <div className={'background '+((workItem.acf.kastner_brand)?' kastner-brand' : '')} >
                <div className="description"  >

                  <div className="inner">
                    {/*<div className="work-type" >
                        <div className="type1"><div className="inner-type" dangerouslySetInnerHTML={{__html:workType1}} /></div>
                        <div className="spacer"></div>
                        <div className="type2"><div className="inner-type" dangerouslySetInnerHTML={{__html:workType2}} /></div>
                    </div> */}
                    <div className="location" dangerouslySetInnerHTML={{__html:workItem.acf.location}}></div>
                    <h5 className="title"><MultiLangText text={titleObj} /></h5>
                    <div className="line" />
                    <div className="copy"  >
                        <div>
                          <MultiLangText text={workItem.acf.description} />
                        </div>
                        <div className="cover">
                            <div className="gradient" />
                        </div>
                    </div>

                  </div>

                  {/*(this.state.showScrollArrow && window.innerWidth < 1025)?
                    <ScrollArrow class="mobile-arrow" style={arrowStyle} />
                  : null*/ }

                  {(this.state.showScrollArrow)?
                    <ScrollArrow className="mobile-arrow" style={arrowStyle} />
                  : null }

                </div>

                {
                  (workItem.acf.kastner_brand)?
                      <KastnerBusinessPopUp />
                    : null
                }

                {/*(this.state.showScrollArrow && window.innerWidth > 1025)?
                  <ScrollArrow  className="desktop-arrow" style={arrowStyle} />
                : null */}



                <div className={"feature-image "+((window.innerWidth<769)? 'scroll-anchor' : '')}>
                  <div className="photo clear" style={featureImageStyle}></div>
                </div>



                <div className="work-content scroll-anchor">

                  {
                    (workItem.acf.work_content)?
                    workItem.acf.work_content.map((item,index) =>{
                        let layout = item.acf_fc_layout
                          if(layout ==='1_image'){

                             return (<WorkOneImageRow key={'wc'+index}  item={item} />);

                          }else if(layout === '2_images'){
                               return <WorkTwoImageRow key={'wc'+index} item={item} />
                          }else if(layout==='image_carousel'){

                            return(<WorkCarousel className="content-row" key={'wc'+index}  {...item} />)

                          }else if(layout==='video'){

                            return(<VideoPlayer className="content-row" key={'wc'+index}  {...item} />)

                          }else if(layout==='video_loop'){
                              return (<VideoLoop  key={'wc'+index}  {...item} />)

                          }else if(layout==='text_section'){
                              return (<TextRow  key={'wc'+index}  {...item} />)
                          }

                    })
                    : null
                  }


                </div>
              </div>

              <MetaTags>
                <meta name="description" content={(workItem.acf.meta_description)? workItem.acf.meta_description : ''} />
              </MetaTags>
          </div>
      )

  }
}

const mapStateToProps = (state) => {
    const workData = state.KastnerStore.workData
    return{
      workData
    }
}

export default connect(mapStateToProps)(WorkItem);



// WEBPACK FOOTER //
// ./src/modules/work/WorkItem.js